import styled from '@emotion/styled'

export const Container = styled('div')`
  width: 100%;
  padding: 40px;
  overflow: hidden;
  position: relative;
`
